// Shared "read/understand a segment" layer. The humanizer (segmentHumanize) and
// trigger-linking (deriveTree/queries) parse a segment's condition tree through
// conditionModel.parseConditions and resolve names via the same helpers here.
import { parseConditions } from './conditionModel';

// Flat attribute refs { attribute_id: String, value } for trigger-linking (deriveTree,
// queries subtree discovery). Products are ignored — only attribute responses link.
export function segmentAttributeRefs(segment) {
  if (!segment) return [];
  const out = [];
  parseConditions(segment.condition).forEach((group) => {
    group.criteria.forEach((criterion) => {
      if (criterion.type === 'attribute' && criterion.attributeId != null) out.push({ attribute_id: String(criterion.attributeId), value: (criterion.values || [])[0] });
    });
  });
  return out;
}

// Union of a segment's attribute refs with all its ancestors' (via parent_segment_id).
// Cycle-safe. LOAD-BEARING: deriveTree/queries use this to link touchpoints to journeys.
export function resolveSegmentRefs(segment, segById) {
  const out = [];
  const seen = new Set();
  let cur = segment;
  while (cur && !seen.has(cur.segment_id)) {
    seen.add(cur.segment_id);
    segmentAttributeRefs(cur).forEach((r) => out.push(r));
    cur = cur.parent_segment_id != null && segById ? segById.get(cur.parent_segment_id) : null;
  }
  return out;
}

// (id) => { name } | null, built from useProductOptions' [{ value:String(id), label }] shape.
// Shared by the card and the drawer so product names resolve identically.
export function buildProductById(productOptions = []) {
  return (id) => {
    const o = productOptions.find((x) => x.value === String(id));
    return o ? { name: o.label } : null;
  };
}
